import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { theme } from 'coreOld/themes';

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>``;

interface DropzoneContainerProps {
  isDragActive?: boolean;
  isDragAccept?: boolean;
  isDragReject?: boolean;
  children?: ReactNode;
}

export const DropzoneContainer = styled.div<DropzoneContainerProps>`
  border: 2px dashed ${theme.palette.hover.borderColor}80;
  padding: 20px;
  transition: border 0.3s ease-in-out;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  ${({ theme, isDragActive }) =>
    isDragActive &&
    css`
      border-color: ${theme.palette.neutral.light};
    `}

  ${({ theme, isDragAccept }) =>
    isDragAccept &&
    css`
      border-color: ${theme.colors.successNt};
    `}

  ${({ theme, isDragReject }) =>
    isDragReject &&
    css`
      border-color: ${theme.colors.dangerNt};
    `}
`;

interface MessageProps {
  children?: ReactNode;
}

export const Message = styled.div<MessageProps>`
  text-align: center;
`;
